import {
  small,
  medium,
  mediumUp,
  large,
  largeUp,
  extraLarge,
  landscape,
  portrait,
  retina,
} from 'constants/mediaQueries';

const Device = class {
  static get isSmall() {
    return window.matchMedia(small).matches;
  }

  static get isMedium() {
    return window.matchMedia(medium).matches;
  }

  static get isMediumUp() {
    return window.matchMedia(mediumUp).matches;
  }

  static get isLarge() {
    return window.matchMedia(large).matches;
  }

  static get isLargeUp() {
    return window.matchMedia(largeUp).matches;
  }

  static get isExtraLarge() {
    return window.matchMedia(extraLarge).matches;
  }

  static get isLandscape() {
    return window.matchMedia(landscape).matches;
  }

  static get isPortrait() {
    return window.matchMedia(portrait).matches;
  }

  static get isRetina() {
    return window.matchMedia(retina).matches;
  }

  static getDeviceType() {
    let deviceType;
    if (Device.isSmall) {
      deviceType = 'mobile';
    } else if (Device.isMedium) {
      deviceType = 'tablet';
    } else {
      deviceType = 'desktop';
    }

    return deviceType;
  }

  static get isAppleDevice() {
    return !!window?.navigator?.userAgent?.match('Mac OS');
  }

  static get isMobile() {
    return this.getDeviceType() == 'mobile';
  }

  static get isTablet() {
    return this.getDeviceType() == 'tablet';
  }

  static get isDesktop() {
    return this.getDeviceType() == 'desktop';
  }
};

export default Device;
